function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16 3a1 1 0 011 1v14.43l3.763-4.106a1 1 0 011.474 1.352l-5.131 5.598a1.5 1.5 0 01-2.212 0l-5.131-5.598a1 1 0 111.474-1.352L15 18.43V4a1 1 0 011-1z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 8a1 1 0 00-1 1v17a1 1 0 001 1h18a1 1 0 001-1V9a1 1 0 00-1-1h-3.5a1 1 0 110-2H25a3 3 0 013 3v17a3 3 0 01-3 3H7a3 3 0 01-3-3V9a3 3 0 013-3h3.5a1 1 0 110 2H7z",
  fill: "currentColor"
})));